import React from "react";
import "./styles/PrivacyPolicy.css";
import { APP_NAME } from "../common/constants";
import SEO from "./SEO";

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <SEO
        title={`Privacy Policy – ${APP_NAME}`}
        description={`Read the privacy policy for ${APP_NAME} — how we collect, store, and protect your data including Google OAuth usage, GDPR compliance, and more.`}
      />
      <div className="privacy-container">
        <h1>Privacy Policy</h1>

        <p>
          Your privacy is important to us. It is <strong>{APP_NAME}</strong>'s policy to respect your privacy regarding any information we may collect from you across our website and other platforms we operate.
        </p>

        <p>
          We only ask for personal information when we truly need it to provide a service to you. Data is collected fairly and lawfully, with your knowledge and consent. We’ll also inform you of why we’re collecting it and how it will be used.
        </p>

        <p>
          You can sign up with your Google account. Your <strong>{APP_NAME}</strong> username will be prefilled with your name and public profile picture.
        </p>

        <p>
          We retain collected data only as long as necessary to fulfill your requests. We protect your information using commercially acceptable security practices to prevent unauthorized access, loss, or misuse.
        </p>

        <p>
          We do not share personally identifying information publicly or with third parties, unless required to by law.
        </p>

        <p>
          <strong>{APP_NAME}</strong> acts as both a data controller and data processor regarding personal data, in accordance with data protection laws like the GDPR.
        </p>

        <p>
          Our website may link to external sites. We are not responsible for the privacy practices of those sites.
        </p>

        <p>
          You may decline to share personal data, understanding that some services may be unavailable as a result.
        </p>

        <p>
          Continued use of our website will be considered acceptance of our privacy practices. If you have any questions about how we handle data, feel free to reach out.
        </p>

        <p className="privacy-updated">This policy is effective as of 17 April 2025.</p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
